export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 6_02.51d2f416.jpg";